import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

var basePath = process.env.BASE_URL || "";

const router = new Router({
  mode: "history",
  base: basePath,
  routes: [
    {
      path: "/",
      name: "default",
      component: require(`@/views/default.vue`).default
    },
    {
      path: "/performance",
      name: "performance-index",
      component: require(`@/views/performance/index.vue`).default
    },
    {
      path: "/performance/:id",
      name: "performance-view",
      component: require(`@/views/performance/view.vue`).default
    },
    {
      path: "/news",
      name: "news-index",
      component: require(`@/views/news/index.vue`).default
    },
    {
      path: "/news/:id",
      name: "news-view",
      component: require(`@/views/news/view.vue`).default
    },
    {
      path: "/examination",
      name: "examination",
      component: require(`@/views/examination.vue`).default
    },
    {
      path: "/about",
      name: "about-index",
      component: require(`@/views/about/index.vue`).default
    },
    {
      path: "/about/director",
      name: "about-director",
      component: require(`@/views/about/director.vue`).default
    },
    {
      path: "/about/artist",
      name: "about-artist",
      component: require(`@/views/about/artist.vue`).default
    },
    {
      path: "/concert-hall",
      name: "hall",
      component: require(`@/views/hall.vue`).default
    },
    {
      path: "/login",
      name: "login",
      component: require(`@/views/login.vue`).default
    },
    {
      path: "/error/:errorCode?",
      name: "error",
      component: require(`@/views/error.vue`).default
    },
    {
      path: "*",
      name: "fallback",
      component: require(`@/views/404.vue`).default
    }
  ]
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router;
